module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/repeat-eda1ec91669e20b92596d50245e197b1.svg";